import http from "./http-common";
import authHeader from "./auth-header";

const getAll = () => {
  return http.get("/prevision", { headers: authHeader() });
};

const get = (id) => {
  return http.get(`/prevision/${id}`,{ headers: authHeader() });
};

const create = (data) => {
   
  return http.post("/prevision", data,{ headers: authHeader() });
};

const update = (id, data) => {
  return http.put(`/prevision/${id}`, data,{ headers: authHeader() });
};

const updateReset = (id) => {
  return http.get(`/prevision/${id}`, { headers: authHeader() });
};

const remove = (id) => {
  return http.delete(`/prevision/${id}`,{ headers: authHeader()});
};

const getPrevisionPerYearAndType = (data) => {
   
  return http.post("/previsionperyear", data,{ headers: authHeader() });
};

const removeAll = () => {
  return http.delete(`/tutorials`);
};

/* const findByTitle = (title) => {
  return http.get(`/tutorials?title=${title}`);
}; */

const findByTitle = (title) => {
  return http.get(`/stock?code=${title}`);
};

const PrevisionService = {
  getAll,
  get,
  create,
  update,
  updateReset,
  remove,
  removeAll,
  findByTitle,
  getPrevisionPerYearAndType,
};

export default PrevisionService;
